import { contactUsConstants, userTypes } from "../MyAccount/myaccount.constants";

export const ypoConciergeConstant = {
    BUTTON_TEXT: "YPO Concierge",
    TITLE: "How may we help you?",
    SUB_TITLE: "Choose an option below to connect with the YPO Concierge.",
    CHAT_TITLE: 'Chat Live Now',
    REQUEST_ASSISTANCE_TITLE: "Ask YPO Concierge",
    PHONE_NUMBER: contactUsConstants.MEMBER_SERVICES_NUMBER,
    PHONE: 'Phone Us',
    CONCIERGE: 'Concierge',
    rolesWithAccessToConcierge: [userTypes.MEMBER, userTypes.TEAM_MEMBER, userTypes.CHAPTER_MANAGER, userTypes.CHAPTER_ADMINISTRATOR, userTypes.SPOUSE_PARTNER],
    M2MX_OPTION: 'M2Mx Request Assistance',
};
